import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionIndExp = props => {
  return (
    <Hoc>
      <CvItem date="Oct 2015" imgSrc="">
        <CvItemDesc descBold="A Residential unit (Villa)" descNormal="Kordan, Iran" descComment="Design Proposal" />
        <CvItemDetail primary bold>
          400 m2 - Architecture, Interior and Landscape
        </CvItemDetail>
      </CvItem>

      <CvItem date="Dec 2010" imgSrc="">
        <CvItemDesc
          descBold="Winning Design for Barid co. Pavilion"
          descNormal="Tehran Elecomp 2010 - Iran"
          descComment="Built"
        />
        <CvItemDetail primary bold>
          Pavilion design
        </CvItemDetail>
        <CvItemDetail> Winning proposal among up to 30 proposals </CvItemDetail>
      </CvItem>
    </Hoc>
  );
};

export default cvSectionIndExp;
